import VModalComponent from './VModal'

export default {
  root: null,
  open(name, props, zIndex) {
    this.root.$set(this.root.modals, name, {
      props,
      zIndex
    })

    this.root.lastModalsNames.push(name)
    document.documentElement.addEventListener('keyup', this.closeByESC.bind(this))
  },
  close(name) {
    if (name) {
      this.root.$delete(this.root.modals, name)

      let index = this.root.lastModalsNames.findIndex(item => item === name)
      if (index < 0) return
      this.root.lastModalsNames.splice(index, 1)
    } else {
      this.root.modals = {}
      this.root.lastModalsNames = []
    }
  },
  blockScroll() {
    const scrollWidth = getScrollWidth();
    document.documentElement.style.overflowY = 'hidden'
    document.documentElement.style.paddingRight = scrollWidth + 'px'
    const headerContent = document.querySelector('.page-header__inner')
    if (headerContent) headerContent.style.paddingRight = scrollWidth + 'px'
  },
  unBlockScroll() {
    if (this.root.lastModalsNames.length) return

    document.documentElement.style.overflowY = null
    document.documentElement.style.paddingRight = null
    const headerContent = document.querySelector('.page-header__inner')
    if (headerContent) headerContent.style.paddingRight = null
  },
  closeByESC(e) {
    if (e.key === 'Escape') {
      if (this.root.lastModalsNames.length) {
        this.close(this.root.lastModalsNames[this.root.lastModalsNames.length - 1])
      }

      if (!this.root.lastModalsNames.length) {
        document.documentElement.removeEventListener('keyup', this.closeByESC)
      }
    }
  },
  install(Vue, options) {
    const {router, store, i18n} = options
    Vue.component('v-modal', VModalComponent)

    // - - - -

    const ModalsList = options.ModalsList
    if (!ModalsList) {
      throw Error(`v-modal plugin aspect property 'rootContainer' in options object. Example: Vue.use(vModal, {rootContainer: vModalContainerComponent})`)
    }

    this.root = new Vue({
      router,
      store,
      i18n,
      data: {
        modals: {
          // 'new-aes-itn': {
          //   props: null
          // }
        },
        lastModalsNames: []
      },
      render: createElement => createElement(ModalsList)
    })

    this.root.$mount(document.body.appendChild(document.createElement('div')))
    this.root.$on('close', () => {
      this.root.gallery.isOpen = false
      this.root.gallery.photos = []
      document.documentElement.removeEventListener('keyup', this.closeByESC)
    })

    Vue.prototype.$vModal = {
      open: this.open.bind(this),
      close: this.close.bind(this),
      blockScroll: this.blockScroll.bind(this),
      unBlockScroll: this.unBlockScroll.bind(this),
    }
  }
}

function getScrollWidth() {
  return (window.innerWidth - document.documentElement.clientWidth) || parseFloat(getComputedStyle(document.documentElement).paddingRight) || 0
}

